import React from 'react';
import { Box, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const DefaultRecommendations = () => {
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    width: "100%",
    alignContent: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, t('domain_search_suite.error.no_domain_with_suggestions')));
};
//# sourceMappingURL=DefaultRecommendations.js.map